// extracted by mini-css-extract-plugin
export default {"wrapper":"nZYLI7msPdz6w6NwoOkr"};